import type { ConsentChoices } from './types';

const CONSENT_KEY = 'consent_v1';
const SESSION_KEY = 'consent_session_id';

export interface StoredConsent {
  choices: ConsentChoices;
  version: string;
  timestamp: string;
}

export function getStoredConsent(): StoredConsent | null {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredConsent;
    if (!parsed.choices || typeof parsed.choices.essential !== 'boolean') {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function setStoredConsent(consent: StoredConsent): void {
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
  } catch {
    // localStorage может быть disabled
  }
}

export function clearStoredConsent(): void {
  try {
    localStorage.removeItem(CONSENT_KEY);
  } catch {
    // ignore
  }
}

export function getOrCreateSessionId(): string {
  try {
    const existing = localStorage.getItem(SESSION_KEY);
    if (existing) return existing;
    const fresh = `sess_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
    localStorage.setItem(SESSION_KEY, fresh);
    return fresh;
  } catch {
    return `sess_${Math.random().toString(36).slice(2)}`;
  }
}
